<ng-container *transloco="let t">
  <div
    class="p-dialog-with-toolbar common-lookup-dialog lookup-dialog-content"
    [ngClass]="dialogId"
    [formGroup]="form"
    (keydown.enter)="login()"
    (document:keydown.control.shift.z)="automaticLogin()"
  >
    <div class="p-fluid grid condensed-row">
      <div class="field col-12 username">
        <span class="p-input-icon-left">
          <i class="fad fa-user"></i>
          <input
            zTextInput
            formControlName="username"
            placeholder="{{ t('auth.timeout.dialog.form.username.placeholder') }}"
            [uppercase]="true"
          />
        </span>
      </div>

      <div class="field col-12 password">
        <span class="p-input-icon-left">
          <i class="fad fa-key"></i>
          <input
            zTextInput
            pPassword
            type="password"
            formControlName="password"
            placeholder="{{ t('auth.timeout.dialog.form.password.placeholder') }}"
            [uppercase]="true"
            [feedback]="false"
          />
        </span>
      </div>
    </div>

    <div class="p-dialog-footer p-dialog-footer-toolbar">
      <p-toolbar styleClass="dialog-toolbar">
        <div class="p-toolbar-group-left"></div>

        <div class="p-toolbar-group-right">
          <p-button label="{{ t('auth.timeout.dialog.controls.login') }}" styleClass="ml-1 p-button-primary" (click)="login()"></p-button>

          <p-button
            label="{{ t('auth.timeout.dialog.controls.cancel') }}"
            styleClass="ml-1 p-button-secondary"
            (click)="cancel()"
          ></p-button>
        </div>
      </p-toolbar>
    </div>
  </div>
</ng-container>
